import React, { FC } from 'react';
import { useAllEmployees } from '~/hooks/employees';
import { Select } from 'antd';

const EmployeeInput: FC<any> = (props) => {
  const { data, isLoading } = useAllEmployees();
  const options = data?.map((item) => ({
    value: item.id as string,
    label: `${item.firstName || ''} ${item.lastName || ''}`,
  }));

  return (
    <Select
      options={options}
      filterOption={(inputValue, option) =>
        (option?.label as string)?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
      }
      showSearch
      disabled={isLoading}
      allowClear
      style={minWidth}
      {...props}
    />
  );
};

const minWidth = { minWidth: 130 };

export default EmployeeInput;
